import { render, staticRenderFns } from "./SubPanel.vue?vue&type=template&id=5721cbb4&scoped=true&"
import script from "./subPanel.ts?vue&type=script&lang=ts&"
export * from "./subPanel.ts?vue&type=script&lang=ts&"
import style0 from "./SubPanel.vue?vue&type=style&index=0&id=5721cbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5721cbb4",
  null
  
)

export default component.exports